<template>
  <Modal name="passwordRequest" :visible="visible">
    <template #title>{{ title }}</template>
    <p v-html="text"></p>

    <form
      class="form-group relative mt-4"
      :class="{ 'form-group-invalid': password.invalid }"
      @submit.prevent="authenticate"
    >
      <input
        v-model="password.value"
        name="project[user_attributes][password]"
        type="password"
        class="form-control rounded-lg pr-10"
        :class="{ 'is-invalid': password.invalid }"
        tabindex="-1"
        autocomplete="current-password"
        @input="password.invalid = false"
      />
      <template v-if="!password.invalid">
        <span class="absolute right-3 top-3 text-slate-300"><fa-icon type="fas" icon="lock-alt" /></span>
      </template>
      <div v-else class="invalid-feedback">Email ou mot de passe invalide.</div>
      <div v-if="password.instructionsState === 'sendable'" class="invalid-feedback small text-muted">
        <p>
          Mot de passe oublié&nbsp;?
          <a href="/users/password/new" @click.prevent="sendLostPasswordInstructions">
            Renvoyer les instructions pour changer de mot de passe
          </a>
          .
        </p>
      </div>
      <div v-else-if="password.instructionsState === 'sending'" class="invalid-feedback small text-muted">
        Envoi de l'email en cours...
        <br />
        Merci de patienter quelques secondes.
      </div>
      <div v-else-if="password.instructionsState === 'sent'" class="invalid-feedback small text-muted">
        Vous allez recevoir un email avec un lien pour changer de mot de passe.
      </div>
      <div v-else-if="password.instructionsState === 'errored'" class="invalid-feedback small text-muted">
        Impossible d'envoyer l'email, notre équipe a été prévenue.
      </div>
    </form>
    <template #actions>
      <button
        class="btn btn-secondary"
        :class="{ disabled: submitting }"
        :disabled="submitting"
        @click.prevent="$emit('close')"
      >
        Annuler
      </button>
      <button class="btn btn-primary" :class="{ disabled: submitting }" :disabled="submitting" @click.prevent="authenticate">
        M'identifier
      </button>
    </template>
  </Modal>
</template>

<script>
import { mapStores } from 'pinia'
import { useMainStore } from '@/apps/fast/store'

import Modal from './Modal.vue'

export default {
  components: {
    Modal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    email: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      password: {
        value: '',
        invalid: false,
        instructionsState: 'sendable'
      },
      submitting: false
    }
  },
  computed: {
    ...mapStores(useMainStore),
    title() {
      return this.mainStore.stepContent('contact')?.passwordRequest.title || 'Identification requise'
    },
    text() {
      return (
        this.mainStore.stepContent('contact')?.passwordRequest.text ||
        "Vous avez déjà un projet en cours d'activation. Vous devez vous identifier pour pouvoir déposer un nouveau projet."
      )
    }
  },
  methods: {
    async authenticate() {
      this.submitting = true
      try {
        const { data } = await this.$http.post('/projects/check-password', {
          project: {
            user_attributes: {
              email: this.email,
              password: this.password.value
            }
          }
        })
        this.$root.sendMatomoPageView('password-valid')
        this.password.invalid = false
        this.$emit('close', data.token)
      } catch (error) {
        console.error(error)
        this.$root.sendMatomoPageView('password-invalid')
        this.password.invalid = true
      }

      this.submitting = false
    },
    async sendLostPasswordInstructions() {
      this.submitting = true
      this.$root.sendMatomoPageView('new-password')
      this.password.instructionsState = 'sending'
      try {
        await this.$http.post('/projects/lost-password', {
          user: {
            email: this.email
          }
        })
        this.$root.sendMatomoPageView('new-password-sent')
        this.password.instructionsState = 'sent'
      } catch (error) {
        this.$root.sendMatomoPageView('new-password-errored')
        this.password.instructionsState = 'errored'
      }
      this.submitting = false
    }
  }
}
</script>
